import React, { useContext } from 'react';
import { CartContext, titles } from '../../Context/CartContext';
import SelectInput from '../FormFields/SelectInput';

function GuestDetails() {
  const [cart, setCart] = useContext(CartContext);
  const rowClass = "flex pt-2";
  const inputWrapper = "flex flex-col pr-2";
  const inputClass = "border text-base";
  const selectClass = "w-24 border text-base"
  const titleList = titles;

  function handleChange(cabinIndex, guestIndex, e, test) {
    
    const name = e.target.name;
    let value = e.target.value;
    if (e.target.type == "checkbox") {
      value = e.target.checked;
    }
    
    let updatedCart = { ...cart };

    if (guestIndex >= 0) { // an additional guest
      updatedCart.cabins[cabinIndex].additionalGuests[guestIndex][name] = value;
    }
    else { // the main guest
      updatedCart.cabins[cabinIndex].mainGuest[name] = value;
    }
    setCart(updatedCart);
  }
  function renderYearOptions() {
    const currentYear = (new Date()).getFullYear();
    return renderOptions(currentYear - 120, currentYear - 18, "Year");
  }
  function renderOptions(from, to, firstOption) {
    let options = [];
    options.push(<option value={0}>{firstOption}</option>);
    for (var i = from; i <= to; i++) {
      options.push(<option key={firstOption + '_' + i} value={i} >{i}</option>);
    }

    return options;
  }
  function getMaxDateOfBirth() {
    let maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);
    let month = maxDate.getMonth() + 1;
    if (month < 10) {
      month = '0' + month;
    }
    const result = maxDate.getFullYear() + '-' + month + '-' + maxDate.getDate();
    return result;
  }
  
  return (
    <React.Fragment>
      {cart.cabins.map((cabin, cabinIndex) =>
        <React.Fragment key={cabin + '_' + cabinIndex}>
          <h5 className="px-4">Guest detail - Cabin {cabinIndex + 1}</h5>
          <div className="p-4 bg-white border">
            <div>
              <span className="text-base font-bold pb-2">Main guest (Adult)</span>
              <div className={rowClass}>
                <div className={inputWrapper}>
                  <label htmlFor={'mainGuestTitle_' + cabinIndex}>Title</label>
                  <select
                    className={selectClass}
                    id={'mainGuestTitle_' + cabinIndex}
                    name="title"
                    value={cabin.mainGuest.title || "default"}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}>
                    <option value="default">Title</option>
                    {titleList.map((title) =>
                      <option key={'mainGuestTitle_' + cabinIndex + '_' + title.id} value={title.id}>{title.label}</option>
                    )}
                  </select>
                </div>
                <div className={inputWrapper}>
                  <label htmlFor="firstName">First Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    id="firstName"
                    name="firstName"
                    value={cabin.mainGuest.firstName}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
                <div className={inputWrapper}>
                  <label htmlFor="lastName">Last Name</label>
                  <input
                    type="text"
                    className={inputClass}
                    id="lastName"
                    name="lastName"
                    value={cabin.mainGuest.lastName}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
              </div>
              <div className={rowClass}>
                <div className={inputWrapper}>
                  <label htmlFor="dateOfBirth">Date of birth</label>
                  <input
                    className={inputClass}
                    type="date" max={getMaxDateOfBirth()}
                    id="dateOfBirth" name="dateOfBirth"
                    value={cabin.mainGuest.dateOfBirth || undefined}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                  {/*
                <div>
                  <select id="day">
                    {renderOptions(1, 31, "Day")}
                  </select>
                  <select id="month">
                    {renderOptions(1, 12, "Month")}
                  </select>
                  <select id="year">
                    {renderYearOptions()}
                  </select>
                </div>
                */}
                </div>
                <div className={inputWrapper}>
                  <label htmlFor="nationality">Nationality</label>
                  <input
                    type="text"
                    className={inputClass}
                    id="nationality"
                    name="nationality"
                    value={cabin.mainGuest.nationality}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
              </div>
              <div className={rowClass}>
                <div className={inputWrapper}>
                  <label htmlFor="email">Email address</label>
                  <input
                    type="email"
                    className={inputClass}
                    id="email"
                    name="email"
                    value={cabin.mainGuest.email}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
                <div className={inputWrapper}>
                  <label htmlFor="phone">Phone number</label>
                  <input
                    type="tel"
                    className={inputClass}
                    id="phone"
                    name="phone"
                    pattern="[0-9]{2} [0-9]{2} [0-9]{2} [0-9]{2}"
                    value={cabin.mainGuest.phone}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
              </div>
              <div className="pt-2">
                <p className="font-bold">Address</p>
                <div className={inputWrapper}>
                  <label htmlFor="street">Street</label>
                  <input
                    type="text"
                    className={inputClass}
                    id="street"
                    name="street"
                    value={cabin.mainGuest.address.street}
                    onChange={(e) => handleChange(cabinIndex, -1, e)}
                  />
                </div>
                <div className={rowClass}>
                  <div className={inputWrapper}>
                    <label htmlFor="zip">Zip code</label>
                    <input
                      type="number"
                      className={inputClass}
                      id="zip"
                      name="zip"
                      min="1000"
                      max="9999"
                      value={cabin.mainGuest.address.zip}
                      onChange={(e) => handleChange(cabinIndex, -1, e)}
                    />
                  </div>
                  <div className={inputWrapper}>
                    <label htmlFor="city">City</label>
                    <input
                      type="text"
                      className={inputClass}
                      id="city"
                      name="city"
                      value={cabin.mainGuest.address.city}
                      onChange={(e) => handleChange(cabinIndex, -1, e)}
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center pt-2">
                <input
                  type="checkbox" id="profile" name="createProfile"
                  checked={cabin.mainGuest.createProfile}
                  onChange={(e) => handleChange(cabinIndex, -1, e)}
                />
                <label className="px-2" htmlFor="profile">Yes, create a User-profile with these data.</label>
              </div>
            </div>
            {cabin.additionalGuests.map((guest, guestIndex) =>
              <div key={'additionalguest_' + cabinIndex + '_' + guestIndex} className="pt-4">
                <p className="text-base font-bold pb-2">Guest {guestIndex + 2} ({guest.guestType})</p>
                <div className={rowClass}>
                  <div className={inputWrapper}>
                    <label htmlFor={'guestTitle_' + cabinIndex + '_' + guestIndex}>Title</label>
                    <select
                      className={selectClass}
                      id={'guestTitle_' + cabinIndex + '_' + guestIndex}
                      name="title"
                      value={guest.title || "default"}
                      onChange={(e) => handleChange(cabinIndex, guestIndex, e)}>
                      <option value="default">Title</option>
                      {titleList.map((title) =>
                        <option key={'guestTitle_' + cabinIndex + '_' + guestIndex + '_' + title.id} value={title.id}>{title.label}</option>
                      )}
                    </select>
                  </div>
                  <div className={inputWrapper}>
                    <label htmlFor="firstName">First Name</label>
                    <input
                      type="text"
                      className={inputClass}
                      id="firstName"
                      name="firstName"
                      value={guest.firstName}
                      onChange={(e) => handleChange(cabinIndex, guestIndex, e)}
                    />
                  </div>
                  <div className={inputWrapper}>
                    <label htmlFor="lastName">Last Name</label>
                    <input
                      type="text"
                      className={inputClass}
                      id="lastName"
                      name="lastName"
                      value={guest.lastName}
                      onChange={(e) => handleChange(cabinIndex, guestIndex, e)}
                    />
                  </div>
                </div>
                <div className={rowClass}>
                  <div className={inputWrapper}>
                    <label htmlFor="dateOfBirth">Date of birth</label>
                    <input
                      className={inputClass}
                      type="date" max={getMaxDateOfBirth()}
                      id="dateOfBirth" name="dateOfBirth" value={guest.dateOfBirth || undefined}
                      onChange={(e) => handleChange(cabinIndex, guestIndex, e)}
                    />
                  </div>
                  <div className={inputWrapper}>
                    <label htmlFor="nationality">Nationality</label>
                    <input
                      type="text"
                      className={inputClass}
                      id="nationality"
                      name="nationality"
                      value={guest.nationality}
                      onChange={(e) => handleChange(cabinIndex, guestIndex, e)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default GuestDetails;